import { BundleProps } from 'utils/types';
import { DynamicTemplate } from '../DynamicTemplate/DynamicTemplate';
import { EDynamicBundleType } from '../DynamicTemplate/constants';

export const DynamicMightyFuCasinoBundle: React.FC<BundleProps> = (props) => {
  return <DynamicTemplate bundleType={EDynamicBundleType.MFC} {...props} />;
};
